var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RoyRect"},[_c('StyledRect',_vm._b({},'StyledRect',_vm.style,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }